import { AlphaTBoxOutlineIcon } from './AlphaTBoxOutlineIcon';

/**
 * author: Contributors
 * id 5AB643B8-7A4C-470B-9C0C-3A3E1E730623
 * name alpha-t-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetTBoxOutlineIcon = AlphaTBoxOutlineIcon;
export default AlphabetTBoxOutlineIcon